export default __webpack_public_path__ + "static/media/stopScreenShare.9d63b08b.svg";